"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StandardPublicConnectionSection;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _config = _interopRequireDefault(require("../../../config"));
var _InfoLinkAndDescription = _interopRequireDefault(require("../common/InfoLinkAndDescription"));
var _DRCInfoLinkAndDescription = _interopRequireDefault(require("../common/DRCInfoLinkAndDescription"));
var _styles = require("../styles");
var _analytics = require("../../../constants/analytics");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function StandardPublicConnectionSection(_ref) {
  var onListingDeeplinkClick = _ref.onListingDeeplinkClick,
    inquireURL = _ref.inquireURL,
    listingId = _ref.listingId,
    _onRequestInformationClick = _ref.onRequestInformationClick;
  var isDRCListing = _config.default.nui.DRCListingId === listingId;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    },
    onClick: onListingDeeplinkClick
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "LoginToConnect"
  })), isDRCListing && inquireURL && /*#__PURE__*/_react.default.createElement(_DRCInfoLinkAndDescription.default, {
    onRequestInformationClick: function onRequestInformationClick() {
      _nuiLogger.default.info({
        description: "New request information link clicked on listing ".concat(listingId),
        'cte.subcategory': 'new-request-info-button-click'
      });
      _onRequestInformationClick(_analytics.elementList.link);
    }
  }), !isDRCListing && inquireURL && /*#__PURE__*/_react.default.createElement(_InfoLinkAndDescription.default, {
    onRequestInformationClick: function onRequestInformationClick() {
      _nuiLogger.default.info({
        description: "New request information link clicked on listing ".concat(listingId),
        'cte.subcategory': 'new-request-info-button-click'
      });
      _onRequestInformationClick(_analytics.elementList.link);
    }
  }));
}
StandardPublicConnectionSection.propTypes = {
  onListingDeeplinkClick: _propTypes.default.func.isRequired,
  inquireURL: _propTypes.default.string,
  listingId: _propTypes.default.string.isRequired,
  onRequestInformationClick: _propTypes.default.func.isRequired
};